import * as React from 'react';

interface IColorCellProps {
  color: string;
}

export default function ColorCell(props: IColorCellProps) {
  return (
    <div
      style={{
        backgroundColor: props.color,
        margin: 'auto',
        height: 20,
        width: 20,
        borderRadius: 5,
        border: '1px #ccc solid',
      }}
    />
  );
}
